// Async two-file boundary (Module Federation RUNTIME-006 fix).
//
// This entry is intentionally SYNCHRONOUS and does nothing but dynamically
// import ./bootstrap. The dynamic import creates the async boundary that lets
// Module Federation initialise the eager shared singletons (vue, vue-router,
// pinia, @vigilance-nz/mfe-shared) BEFORE any module that consumes them is evaluated.
// Without it, the host trips `loadShareSync` (RUNTIME-006) and renders a blank
// page when loaded standalone. ./bootstrap owns the entire app lifecycle.
//
// The import is fire-and-forget, so a failure here (module evaluation throwing
// before Vue even mounts) would silently white-screen. Catch it and paint a
// minimal, brand-neutral error shell with plain `document` APIs — NOT Vue,
// since Vue itself may be what failed to load.
import('./bootstrap').catch((err) => {
  console.error('[main] Failed to bootstrap the application:', err)
  const root = document.querySelector('#app')
  if (root) {
    root.innerHTML
      = '<div style="display:flex;align-items:center;justify-content:center;'
        + 'min-height:100vh;font-family:sans-serif;text-align:center;padding:1rem;">'
        + 'Something went wrong loading the application. Please refresh.'
        + '</div>'
  }
})
